import type * as React from 'react'

import { isAxiosError as isAxiosErrorGeneric } from 'axios'

import { Banner, Button } from '@b-stock/fe-core/bstock-react'

const ErrorBanner = ({
  title,
  children,
}: {
  title?: string
  children?: React.ReactNode
}) => {
  return (
    <Banner type="error" title={title}>
      {children}
    </Banner>
  )
}

export const isAxiosError = isAxiosErrorGeneric<{
  errorMessage?: string
  message?: string
}>

export const ErrorBannerComponent = ({
  error,
  refetch,
  errorMessage,
  errorTitle = 'Error',
}: {
  error?: unknown
  refetch?: () => void
  errorMessage?: string
  errorTitle?: string
}) => {
  // Skip error handling logic if errorMessage is provided
  const { message, mayRetry } = errorMessage
    ? { message: errorMessage, mayRetry: false }
    : handleError(error)

  return (
    <ErrorBanner title={errorTitle}>
      {message}
      {mayRetry && typeof refetch !== 'undefined' && (
        <div>
          <Button onClick={refetch}>Retry</Button>
        </div>
      )}
    </ErrorBanner>
  )
}

// Helper function to handle error processing
const handleError = (error: unknown) => {
  let message = 'Unexpected error'
  let mayRetry = false

  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    message =
      "You don't appear to be connected to the internet. Re-establish your connection and try again."
    mayRetry = true
  } else if (isAxiosError(error)) {
    const status = error.response?.status

    if (!status) {
      //  Just use the default messaging.
    } else if (status === 404) {
      message = 'The requested resource could not be found'
    } else if (status === 403 || status === 401) {
      message = 'You do not have permission to access this resource'
    } else if (~~(status / 100) === 5) {
      message = 'Temporary server error, retry later.'
      mayRetry = true
    } else if (status === 400) {
      message = error.response?.data.errorMessage || error.message
    }
  }

  return { message, mayRetry }
}

export default ErrorBanner
